export default "/images/1632d1cf554390a787aed1bebb4dd4b1.avif";